var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImprovePrompt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "strategy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2751 4.85685C17.3541 5.19285 17.1458 5.52933 16.8098 5.60839C13.2944 6.43554 10.7217 7.44675 8.91908 9.15196C7.13582 10.8388 6.02864 13.2816 5.62157 17.1488C5.58543 17.492 5.27785 17.741 4.93457 17.7049C4.59129 17.6688 4.3423 17.3612 4.37843 17.0179C4.8047 12.9684 5.98918 10.2028 8.06008 8.24387C10.1116 6.30325 12.9556 5.23112 16.5235 4.39161C16.8595 4.31256 17.196 4.52085 17.2751 4.85685Z",
    fill: "#9897A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5619 5.18192C17.7078 4.86908 17.5725 4.49722 17.2596 4.35134L13.5213 2.60813C13.2085 2.46225 12.8366 2.59759 12.6907 2.91043C12.5448 3.22327 12.6802 3.59513 12.993 3.74101L16.1649 5.22009L14.6858 8.39197C14.54 8.70481 14.6753 9.07667 14.9881 9.22255C15.301 9.36843 15.6728 9.23308 15.8187 8.92025L17.5619 5.18192Z",
    fill: "#9897A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16667 3.125C3.59137 3.125 3.125 3.59137 3.125 4.16667C3.125 4.74196 3.59137 5.20833 4.16667 5.20833C4.74196 5.20833 5.20833 4.74196 5.20833 4.16667C5.20833 3.59137 4.74196 3.125 4.16667 3.125ZM1.875 4.16667C1.875 2.90101 2.90101 1.875 4.16667 1.875C5.43232 1.875 6.45833 2.90101 6.45833 4.16667C6.45833 5.43232 5.43232 6.45833 4.16667 6.45833C2.90101 6.45833 1.875 5.43232 1.875 4.16667Z",
    fill: "#9897A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8914 12.8914C13.1355 12.6473 13.5312 12.6473 13.7753 12.8914L15.1011 14.2172L16.4269 12.8914C16.671 12.6473 17.0667 12.6473 17.3108 12.8914C17.5549 13.1355 17.5549 13.5312 17.3108 13.7753L15.985 15.1011L17.3108 16.4269C17.5549 16.671 17.5549 17.0667 17.3108 17.3108C17.0667 17.5549 16.671 17.5549 16.4269 17.3108L15.1011 15.985L13.7753 17.3108C13.5312 17.5549 13.1355 17.5549 12.8914 17.3108C12.6473 17.0667 12.6473 16.671 12.8914 16.4269L14.2172 15.1011L12.8914 13.7753C12.6473 13.5312 12.6473 13.1355 12.8914 12.8914Z",
    fill: "#9897A6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImprovePrompt);
export default __webpack_public_path__ + "static/media/improve_prompt.c81f32b483f69cebfb4158954a9bbe31.svg";
export { ForwardRef as ReactComponent };